import { render, staticRenderFns } from "./PurchasesInvoiceListTable.vue?vue&type=template&id=67fc549e"
import script from "./PurchasesInvoiceListTable.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports